var common = require("../../utiles/common.js");
var message = require("../../utiles/message.js");

module.exports = {
  register: function () {
    document.createElement("app-list");
    ko.components.register("app-list", {
      viewModel: function (params) {
        var $this = this;
        var runApp = common.urlSearch(location.href)["runApp"];
        console.log(runApp);
        $this.visible = ko.observable(false);
        $this.formVisible = ko.observable(false);
        var items = common.fetch("/auth/account/app/list").data;
        var allapp = commonLocal.app.allapp;
        $this.items = ko.observableArray(items);
        $this.activeType = ko.observable(allapp);
        $this.item = ko.observable("");
        $this.config = ko.observable("");
        $this.options = ko.observableArray();
        var getAppClassification = common.fetch(
          "/auth/account/app/getAppClassification"
        ).data;
        $this.category = getAppClassification
          ? JSON.parse(getAppClassification.appClassJson)
          : { allapp: [] };
        if (runApp) {
          for (var i = 0; i < items.length; i++) {
            if (items[i].url == runApp) {
              $this.item(items[i]);
              $this.options(items[i].accountNameList);
              $this.visible(true);
            }
          }
        }

        $this.getCategory = function (category) {
          var categoryList = [allapp];
          for (var c in category) {
            if (c != allapp) {
              // 分组数据大于0时展示出来
              if (category[c].length > 0) {
                categoryList.push(c);
              }
            }
          }
          return categoryList;
        };
        $this.types = $this.getCategory($this.category);
        console.log($this.types);
        $this.getApps = function (list) {
          console.log(list);
          var appList = [];
          for (var i = 0; i < items.length; i++) {
            if (list.indexOf(items[i].id) > -1) {
              appList.push(items[i]);
            }
          }
          return appList;
        };
        $this.changeType = function (type) {
          $this.activeType(type);
          var selectList = $this.category[type] ? $this.category[type] : [];
          if (type === allapp) {
            $this.items(items);
          } else {
            $this.items($this.getApps(selectList));
            console.log($this.items());
          }
        };
        $this.isEnable = function (event) {
          $this.visible($this.visible() ? false : true);
        };
        $this.coverSSO = function () {
          var account = $("#maskApp").val();
          var param = "";
          // 如果传给login页面state参数时就在选择时传给后端
          if (sessionStorage.getItem("state")) {
            param = "&state=" + sessionStorage.getItem("state");
          }
          // 如果带了参数就使用带过来的参数
          if (common.urlSearch(location.href)["state"]) {
            param = "&state=" + common.urlSearch(location.href)["state"];
          }
          if (sessionStorage.getItem("searchUrl")) {
            param += "&" + sessionStorage.getItem("searchUrl");
          } else if (common.urlSearch(location.href)["callback"]) {
            param += "&callback=" + common.urlSearch(location.href)["callback"];
          }
          window.open(
            "/auth/sso/login/" +
              $this.item().url +
              "?accountName=" +
              account +
              param,
            "_blank"
          );
        };
        $this.getConfig = function (params) {
          console.log(params);
          $this.config(params);
          $this.formVisible(true);
          if (params.accountName) {
            $("#accountName").val(params.accountName);
            $("#password").val("");
          }
        };

        $this.updateApp = function () {
          var postD = $(".formFill input").serializeObject();
          postD.appCode = $this.config().appId;
          postD.accountId = $this.config().accountId;
          console.log(postD);
          if (!postD.accountName) {
            message.messageG("error", "请输入账号");
            return false;
          }
          if (!postD.password) {
            message.messageG("error", "请输入密码");
            return false;
          }
          common.fetch("/auth/account/manager/manageAccount", {
            type: "POST",
            data: JSON.stringify(postD),
            handleError: function (data) {},
            success: function (result) {
              console.log(result);
              $this.formVisible(false);
              if (postD.accountId) {
                message.messageG("success", "修改成功");
              } else {
                message.messageG("success", "添加成功");
              }
              $this.items(common.fetch("/auth/account/app/list").data);
            },
          });
        };
      },
      template: require("./template/AppList.html"),
    });
    document.createElement("app-card");
    ko.components.register("app-card", {
      viewModel: function (params) {
        var $this = this;
        var ua = navigator.userAgent.toLowerCase();
        var isIE = ua.indexOf("msie") > -1;
        var safariVersion;
        if (isIE) {
          safariVersion = ua.match(/msie ([\d.]+)/)[1];
        }
        $this.app = params.app;
        $this.mId = ko.observable("");
        //console.log($this.app)
        $this.accountDropMenu = {
          isDropMenuDisplay: ko.observable(false),
          className: "accountDropMenu",
          items: ko.observableArray(),
          id: $this.app.id,
        };
        $this.defaultEntitlement = ko.observable();
        $this.defaultEntitlement.subscribe(function (newValue) {
          var options = $this.accountDropMenu.items;
          options.removeAll();
          for (i in $this.app.accountNameList) {
            var accountName = $this.app.accountNameList[i].displayName;
            if (newValue.displayName !== accountName) {
              options.push({
                name: accountName,
                index: i,
                icon: "",
                action: function (data) {
                  $this.defaultEntitlement(
                    $this.app.accountNameList[data.index]
                  );
                  $this.triggerDropMenu();
                  console.log($this.defaultEntitlement());
                },
              });
            }
          }
          var oArrs = [];
          if (safariVersion == 8.0) {
            for (var i = 0; i < options().length; i++) {
              if (options()[i].name) {
                oArrs.push(options()[i]);
              }
            }
            $this.accountDropMenu.items(oArrs);
          }
        });
        $this.selectTimes = function (time) {
          if (time == 0) {
            return "未使用";
          } else {
            return common.selectTimes(time) + "前";
          }
        };
        $this.defaultEntitlement(
          $this.app.accountNameList ? $this.app.accountNameList[0] : ""
        );
        $this.triggerDropMenu = function (e) {
          var old = $this.accountDropMenu.isDropMenuDisplay();
          $this.accountDropMenu.isDropMenuDisplay(!old);
        };

        $this.openUpdate = function () {
          if (params.getConfig) {
            params.getConfig({
              appId: $this.app.appCode,
              accountName: $this.defaultEntitlement().accountName,
              accountId: $this.defaultEntitlement().accountId,
            });
          }
        };

        $this.sso = function () {
          if (params.getConfig) {
            if (
              $this.app.ssoEntranceType === "FORM" &&
              $this.app.accountNameList &&
              $this.app.accountNameList.length === 0
            ) {
              params.getConfig({
                appId: $this.app.appCode,
              });
              return false;
            }
          }
          var account = $this.defaultEntitlement()
            ? $this.defaultEntitlement().accountName
            : "";
          var subjectId = $this.defaultEntitlement()
            ? $this.defaultEntitlement().subjectId
            : "";
          var url = "?accountName=" + account + "&subjectId=" + subjectId;
          var isLogin = common.fetch("/auth/isLogin").data;
          console.log(isLogin);
          if (isLogin) {
            window.open("/auth/sso/login/" + $this.app.url + url, "_blank");
          } else {
            common.redirectTo("/#/");
          }
        };
        var arrs = [];
        if (safariVersion == 8.0) {
          for (var i = 0; i < $this.accountDropMenu.items().length; i++) {
            if ($this.accountDropMenu.items()[i].name) {
              arrs.push($this.accountDropMenu.items()[i]);
            }
          }
          $this.accountDropMenu.items(arrs);
        }
        $this.appConfig = function (e) {
          //e.stopPropagation();
          common.redirectTo("/#/appConfig/" + $this.app.id);
        };
      },
      template: require("./template/AppCard.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/appList/AppList.js
// module id = 119
// module chunks = 0